import React from 'react';
import { Stack, Typography } from '@mui/material';
import moment from 'moment';
import ChipSocialMediaObject from 'src/components/ChipSocialMediaObject';

interface Props {
  detail: any;
}

const InformationDetailFirstTimeSocialMediaData: React.FC<Props> = ({
  detail
}) => {
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography variant="h5">Get Data For: </Typography>
        <ChipSocialMediaObject
          name={
            detail.streamType === 'account'
              ? `@${detail.objectName}`
              : detail.objectName
          }
          socialMedia={detail.socialMedia}
          streamType={!detail.isHashtag ? detail.streamType : undefined}
          sx={{
            m: '0 8px 8px 0',
            cursor: 'pointer'
          }}
          id=""
        />
      </Stack>
      <Typography variant="subtitle2">{`Created At : ${moment(
        detail.createdAt
      ).format('DD MMM YYYY')}`}</Typography>
    </Stack>
  );
};

export default InformationDetailFirstTimeSocialMediaData;
